<template>
    <div :class="{avatar : true, checked : checked, [typeNetwork]:true, toggleDisplayReseau : toggleDisplayReseau}" @click="$emit('click',$event,id)">
       <img :src="urlPicture ? urlPicture : 'img/avatar.jpg'">
    </div>
</template>

<script>
export default {
    name: 'avatar',

    props: {
        keyUnique: String,

        urlPicture: {
            default: 'img/avatar.jpg',
            type: String
        },

        typeNetwork: {
            default: 'facebook',
            type: String
        },

        checkIsPossible: {
            default: false,
            type: Boolean
        },

        checked: {
            default: false,
            type: Boolean
        },

        toggleDisplayReseau: {
            default: false,
            type: Boolean
        },

        id: String
    },

    data() {
        return {
            
        };
    },

    mounted() {
       
    },

    methods: {
        handleCheckboxChange(event) {
            console.log('Checkbox value changed:', event.target.checked);
        }
        
    },

    
};
</script>